module.exports = __webpack_public_path__ + "img/20200529_142704.f271e260.jpg";